@if (availableTypes$ | async; as availableTypes) {
    @for (typeInfo of availableTypes; track typeInfo) {
        <bs-system-bet-type-container [systemTypeInfo]="typeInfo" [isEpcotEnabled]="isEpcotEnabled" [oddsDisplayFormat]="oddsDisplayFormat" />
    }
}
